import React, { useEffect, useState } from "react"
import PageSections from "../PageSections/PageSections"
import useRawErrorData from "../../utils/hooks/useRawErrorData"
import useErrorData from "../../utils/hooks/useErrorData"
import Cookies from "js-cookie"
import { returnActiveOverlayNotice } from "../OverlayNotice/OverlayNoticeMethods"
import useLanguage from "../../utils/hooks/useLanguage"

const RegionBlockPage = ({
  pageContent,
  location,
  locale = "en",
  appData,
  productPage,
  region,
  siteAppData,
  currentSpaceId,
  products,
  siteIdentifier,
  isPageSection,
}) => {
  return <>{<PageSections pageSections={pageContent} />}</>
}

export default RegionBlockPage
